import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { key: 0 }

import { computed, onMounted, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'

    import { usePortfolioPlanningModuleStatusQueryV1 } from '@Quest/Portfolios/queries-vue-composables'

    import type { PortfolioPlanningModuleStatusReadModel } from '@Quest/Portfolios/readmodels'

    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PortfolioPlanningEntrancePage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))

    // ======================
    // Query
    // ======================

    const {
        runPortfolioPlanningModuleStatusQueryV1,
        modelPortfolioPlanningModuleStatusQueryV1
    } = usePortfolioPlanningModuleStatusQueryV1(workspaceId, tchProjectId)

    const rm = modelPortfolioPlanningModuleStatusQueryV1 as Ref<PortfolioPlanningModuleStatusReadModel | null>

    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Portfolio planning | TransparentChoice"
        runPortfolioPlanningModuleStatusQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"row\"><div class=\"col-lg-6\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;margin:0;\">Portfolio Planning - Beta Version</h1></div><div class=\"col-lg-6 text-right align-self-end\"></div></div><hr style=\"border-color:#bbb;margin:20px 0 60px;\">", 2)),
          (_unref(rm))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("p", null, " Please note that the Portfolio Planning feature is currently in its beta phase and is not enabled on this portfolio. We are actively working on refining this tool to ensure it meets our high standards of performance and user experience. ", -1 /* CACHED */),
                _createElementVNode("p", null, " If you're interested in exploring the Portfolio Planning feature and would like to request beta access, we encourage you to contact us. We value your interest and are eager to involve our users in the development process. By contacting us, you can gain early access and provide valuable feedback to help shape this feature. We are more than happy to provide detailed information and updates, and we look forward to hearing from you. ", -1 /* CACHED */),
                _createElementVNode("p", null, "Thank you for your understanding and support as we continue to enhance our services.", -1 /* CACHED */)
              ]))]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})